export { NavigationIndicatorModule } from './navigation-indicator.module';
export { NavigationIndicatorService } from './navigation-indicator.service';